import $ from 'jquery';

var AccountMenu = function () {
    
    var menushown = false;    
    var authopen = false;

    return {
        init: function () {
            $(".aixacc").click(function (e) {
                $(".accountinfo").css('display', 'block');
                menushown = true;
                e.preventDefault();
                return;
            });
            
            $(".accchooser").click(function (e) {
                var me = $(this);
                if (!me.hasClass('accchooser')) {
                    me = me.parents('.accchooser');
                }
                var user = me.attr('data-mail');
                var ref = window.location;
                if (user) {
                    if (window.location.search) {
                        window.location.search += "&setuser=" + user;
                    } else {
                        window.location.search = "?setuser=" + user;
                    }
                }                                
                e.preventDefault();
                return;
            });
            
            $(".closedauth h2").click(function () {
                if (!authopen) {
                    $(".closedauth form").show();
                    authopen = true;
                } else {
                    $(".closedauth form").hide();
                    authopen = false;
                }
                    
            });

            $(document).click(function (e) {
                if (menushown) {
                    if (($(e.target).closest('.accountinfo').length) || $(e.target).is('.accountinfo, .accountinfo *')) {
                        // we are within the menu: do nothing
                        return;
                    }
                    else {
                        if (($(e.target).closest('.aixacc').length) || $(e.target).is('.aixacc, .aixacc *')) {
                            // we clicked on top link: dont remove the menu
                            return;
                        }
                        $(".accountinfo").css('display', 'none');
                        menushown = false;
                        // click outside of menu. it is modal so dont propagate events
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }
                }
            });
        },
    };
}();

$(document).ready(function () {
    AccountMenu.init();
});